import React from 'react';

// Бейдж живёт в ячейке таблицы, а у td стоит word-break: break-word — без минимальной
// ширины колонка схлопывается и статус рвётся по буквам ("НАЗН АЧЕН МЕН ЕДЖ ЕР").
const Status = ({ status, color, backgroundColor, minWidth = 96 }) => {
  return (
    <div
      style={{
        backgroundColor: backgroundColor || 'white',
        border: `1px solid ${color}`,
        borderRadius: '2px',
        padding: '3px 8px',
        width: '100%',
        minWidth,
        boxSizing: 'border-box',
      }}
    >
      <p
        style={{
          textTransform: 'uppercase',
          color: color,
          fontFamily: 'Exo 2',
          fontWeight: 600,
          fontSize: '10px',
          lineHeight: '15px',
          textAlign: 'center',
          wordBreak: 'normal',
        }}
      >
        {status}
      </p>
    </div>
  );
};

export default Status;
